/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { SearchUserResult } from 'src/app/models/user';
import { LocalStorageService } from 'src/app/services/local-storage/local-storage/local-storage.service';
import { ProductsService } from 'src/app/services/products/products.service';

// Dialog box to allow an internal user to search for customers
@Component({
  selector: 'wsn-search-customers',
  templateUrl: './search-customers.component.html',
  styleUrls: ['./search-customers.component.scss']
})
export class SearchCustomersComponent {
  public readonly pageSize = 10;
  pageNumber = 0;
  loadingResults = false;

  searchTerm = '';
  searchResults: SearchUserResult[] = [];
  searchResultsPage: SearchUserResult[] = [];
  selectedResult: SearchUserResult = undefined;

  constructor(
    public dialogRef: MatDialogRef<SearchCustomersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productService: ProductsService,
    private localStorageService: LocalStorageService,
    private detector: ChangeDetectorRef
  ) {}

  search() {
    if (this.searchTerm.length > 2) {
      this.loadingResults = true;
      this.productService.searchCustomers(this.searchTerm).subscribe((results) => {
        this.loadingResults = false;
        this.searchResults = results;
        this.searchResultsPage = this.searchResults.slice(0, this.pageSize);
        this.pageNumber = 0;
        this.detector.detectChanges();
      });
      this.selectedResult = undefined;
    }
  }

  onClickResult(selectedResult: SearchUserResult) {
    this.selectedResult = selectedResult;
  }

  handlePageEvent(event: PageEvent) {
    this.pageNumber = event.pageIndex;
    const start = this.pageNumber * this.pageSize;
    const end = start + this.pageSize;
    this.searchResultsPage = this.searchResults.slice(start, end);
  }

  selectCustomer() {
    this.localStorageService.addRecentUser(this.selectedResult);
    this.dialogRef.close(this.selectedResult);
  }

  cancel() {
    this.dialogRef.close({});
  }
}
